module.exports = __webpack_public_path__ + "static/img/sfbt.2e9e0e3e.png";